import { render, staticRenderFns } from "./custom_foods_recipes.vue?vue&type=template&id=58e05804&scoped=true&"
import script from "./custom_foods_recipes.vue?vue&type=script&lang=js&"
export * from "./custom_foods_recipes.vue?vue&type=script&lang=js&"
import style0 from "./custom_foods_recipes.vue?vue&type=style&index=0&id=58e05804&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e05804",
  null
  
)

export default component.exports